export default __webpack_public_path__ + "static/media/checkIcon.9546dced.svg";